// SPDX-License-Identifier: AGPL-3.0-or-later

import type {MessageEmbed} from '@konvo/schema/src/domains/message/EmbedSchemas';

// Keep these source labels aligned with push_notification.erl for background push.
const CARD_LABELS: Readonly<Record<string, string>> = {
	'Konvo:clickup': 'Konvo · Tasks',
	'Konvo:calendar': 'Outlook · Calendar',
	'Konvo:agenda': 'Konvo · Agenda',
	'Konvo:digest': 'Konvo · Summary',
	'Konvo:reminder': 'Konvo · Reminders',
	'Konvo:time': 'Konvo · Time',
};

export function buildMessageNotificationTitle(context: string, embeds: ReadonlyArray<MessageEmbed> = []): string {
	for (const embed of embeds) {
		const provider = embed.provider?.name;
		const label = provider && Object.hasOwn(CARD_LABELS, provider) ? CARD_LABELS[provider] : undefined;
		if (label) return `${label} · ${embed.title || context}`;
	}
	return `Konvo · Messages · ${context}`;
}
